import { Component, OnInit, Input } from '@angular/core';
import { AuthenticationService } from '../auth/authentication.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  @Input() hq = false;

  constructor(public authService: AuthenticationService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/menu/menu.component.ts